var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPfeilDropdownRunter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Pfeil-Dropdown-runter__Icn/40px/Pfeil-Dropdown-runter",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Pfeil-Dropdown-runter__Icn/20px/Icon-Platzhalter-Transparent",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Pfeil-Dropdown-runter__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.5,15 L27,25 L14,25 L20.5,15 Z M20.5,18.005 L17.0363125,23.3333333 L23.962875,23.3333333 L20.5,18.005 Z",
    id: ".._.._src_svg_Icn_40px_Pfeil-Dropdown-runter__Triangle",
    transform: "matrix(1 0 0 -1 0 40)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPfeilDropdownRunter);
export default __webpack_public_path__ + "static/media/Pfeil-Dropdown-runter.fc320beab3f2c60b56604d01ed1c8177.svg";
export { ForwardRef as ReactComponent };